import Section from '@app/components/atoms/Section/Section'
import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { usePage } from '@inertiajs/inertia-react'
import { useTranslation } from 'react-i18next'

export default function VoucherPos() {
  const {
    props: { pos, routeName, voucher },
  } = usePage()
  const { t } = useTranslation()

  return (
    <Section simple>
      <DataGrid
        enableIndexColumn
        columns={[
          {
            id: 'address',
            Header: t('POS.ADDRESS'),
            accessor: 'address',
            type: 'string',
          },
          {
            id: 'city',
            Header: t('POS.CITY'),
            accessor: 'city',
            type: 'string',
          },
          {
            id: 'longitude',
            Header: t('POS.LONGITUDE'),
            accessor: 'longitude',
            type: 'string',
            disableFilters: true,
            disableSortBy: true,
          },
          {
            id: 'latitude',
            Header: t('POS.LATITUDE'),
            accessor: 'latitude',
            type: 'string',
            disableFilters: true,
            disableSortBy: true,
          },
        ]}
        data={pos}
        enableCollapseFilter={false}
        params={{ merchant: voucher.merchant_id, voucher: voucher.id, tab: 'pos' }}
        queries={{ merchant: voucher.merchant_id, voucher: voucher.id, tab: 'pos' }}
        routeName={routeName}
      />
    </Section>
  )
}
